import {useActivateApiAbTestCallback} from '@aboutyou/feature-flags';
import {
  useIsBrandPage,
  useIsCategoryPage,
  useIsCouponLandingPage,
  useIsSimilarProductsPage,
} from '@aboutyou/router';
import {useEffect} from 'react';

export const ActivateExcludedAssortmentABTest = () => {
  const isCategoryPage = useIsCategoryPage();
  const isBrandShop = useIsBrandPage();
  const isSimilarProducts = useIsSimilarProductsPage();
  const isCouponLandingPage = useIsCouponLandingPage();
  const activateApiAbTest = useActivateApiAbTestCallback();

  useEffect(() => {
    if (
      isCategoryPage ||
      isBrandShop ||
      isSimilarProducts ||
      isCouponLandingPage
    ) {
      activateApiAbTest('ab_exclude_assortment_iii');
    }
  }, [
    isCategoryPage,
    isBrandShop,
    isSimilarProducts,
    isCouponLandingPage,
    activateApiAbTest,
  ]);

  return null;
};
